module.exports = __webpack_public_path__ + "static/img/pdf.77dbe38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdf.jpg
// module id = 8f8P
// module chunks = 18